import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { $, merge, media } from "glamor";
import { RadioButtonGroup, RadioButton } from "material-ui/RadioButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

export const ProductCollectionCatalogsSidebar: React.FunctionComponent<IProductCollectionCatalogSidebarProps> = ({
    location,
    catalogType,
    router,
}) => {
    const style = React.useMemo(() => {
        return merge(
            {
                padding: "12px",
                width: "200px",
            },
            $(" .selectField", {
                display: "none !important",
            }),
            media(
                "(max-width: 540px)",
                {
                    padding: "8px",
                    width: "100%",
                },
                $(" .radioButtonGroup", {
                    display: "none",
                }),
                $(" .selectField", {
                    display: "inline-block !important",
                    width: "100% !important",
                })
            )
        );
    }, []);
    const handleChange = React.useCallback((_e, value: string) => {
        if (!value) {
            router.push(location.pathname);
        } else {
            router.push(`${location.pathname}?type=${value}`);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSelectChange = React.useCallback((e, _index: number, value: string) => {
        handleChange(e, value);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const values = React.useMemo(() => {
        return [
            { value: undefined, label: formatMessage("All Catalogs") },
            { value: "linesheet", label: formatMessage("Linesheets") },
            { value: "custom-list", label: formatMessage("Custom Lists") },
        ];
    }, []);

    return (
        <div {...style}>
            <RadioButtonGroup
                className="radioButtonGroup"
                name="catalog"
                valueSelected={catalogType}
                onChange={handleChange}
            >
                {values.map(({ value, label }, i) => (
                    <RadioButton key={i} value={value} label={label} />
                ))}
            </RadioButtonGroup>
            <SelectField className="selectField" value={catalogType} onChange={handleSelectChange}>
                {values.map(({ value, label }, i) => (
                    <MenuItem key={i} value={value} primaryText={label} />
                ))}
            </SelectField>
        </div>
    );
};

export interface IProductCollectionCatalogSidebarProps {
    location: any;
    catalogType?: "custom-list" | "linesheet";
    router: any;
}
